import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { categories } from '../data/categories';
import { mexicanStates } from '../data/states';

export default function SearchBar({ compact = false }) {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [categoria, setCategoria] = useState('');
  const [estado, setEstado] = useState('');
  const states = mexicanStates;

  const handleSubmit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (q) params.set('q', q);
    if (categoria) params.set('categoria', categoria);
    if (estado) params.set('estado', estado);
    navigate(`/buscar?${params.toString()}`);
  };

  return (
    <form className={`search-bar ${compact ? 'compact' : ''}`} onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Busca por nombre de proveedor, ej. 'salón', 'DJ'..."
        value={q}
        onChange={(e) => setQ(e.target.value)}
        aria-label="Buscar proveedor"
      />
      <select value={categoria} onChange={(e) => setCategoria(e.target.value)} aria-label="Filtrar por categoría">
        <option value="">Todas las categorías</option>
        {categories.map((c) => (
          <option value={c.slug} key={c.slug}>{c.icon} {c.name}</option>
        ))}
      </select>
      <select value={estado} onChange={(e) => setEstado(e.target.value)} aria-label="Filtrar por estado">
        <option value="">Todos los estados</option>
        {states.map((s) => (
          <option value={s} key={s}>{s}</option>
        ))}
      </select>
      <button type="submit" className="btn btn-primary">Buscar</button>
    </form>
  );
}
